export const BetrGrRV = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'keine RV',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'voller Beitrag',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'halber Beitrag',
  },
  {
    'PAISY Wert': 5,
    Bezeichnung: 'pauschal GFB',
  },
];
